import * as React from 'react';
import Helmet from 'react-helmet';
import { withRouter, WithRouterProps } from 'react-router';

import { withIntl, IntlProps } from 'ha/i18n';
import { withConfig, ConfigProps } from 'ha/helpers/config';

export const Meta: React.SFC<IntlProps & WithRouterProps & ConfigProps> = ({
  intl: { T, urlResolver, lang },
  location,
  appConfig: { cdnDomain },
}) => (
  <Helmet defaultTitle="HousingAnywhere: Mid to Long-Term Rentals in 400+ cities.">
    <html lang={lang} />
    <meta name="description" content={T('meta_description')} />
    <meta property="og:description" content={T('meta_description')} />
    <meta property="og:type" content="housinganywhere:listing" />
    <meta property="og:site_name" content="Housing Anywhere" />
    <meta
      property="og:url"
      content={urlResolver.absolutizePath(location.pathname, {
        skipAddLanguage: true,
      })}
    />
    <meta property="og:title" content="Housing Anywhere" />
    <meta property="og:image" content={`${cdnDomain}/img/logo_600x315.png`} />
  </Helmet>
);

export default withRouter(withConfig(withIntl(Meta)));
